ACC.amdslogout = {

	_autoload: [
		"logoutGoogleTag",
	],

	logoutGoogleTag : function (){

		$(document).on("click", ".js-logout", function (e) {
			
		 	 if($.cookie('isAbandonedCart') != null)
		 	 {
		 		$.cookie('isAbandonedCart', null, {path:'/'})
		 	 }
/*			window.dataLayer.push({
				'event':'authentification',
				'userID':user.userId,
				'userType':user.userType
		
			});*/

		 	 var isASMCustomer = $("#isASMCustomer").attr('value');
		 	 if(isASMCustomer === 'true'){
                 $.ajax({
                     url: ACC.config.encodedContextPath +"/assisted-service/personify-stop",
                     method:"POST",
                     traditional : true,
                     success:function(response) {
						 window.location.replace(ACC.config.encodedContextPath);
                     },
                 });
             }

		});
	},
};
